import React from 'react';
import LegalPageLayout from './LegalPageLayout';
import { TERMS_OF_USE } from './legalContent';

function TermsOfUse() {
  return <LegalPageLayout {...TERMS_OF_USE} />;
}

export default TermsOfUse;
